import React from 'react';
import MenuLink from './MenuLink';
import { HelpIcon, FolderIcon } from '../../svg';

function SideMenuBar({ faqData, privacyData }) {
	return (
		<div className='menu__wrapper'>
			<div className='d-flex mb-40'>
				<HelpIcon />
				<ul className='ml-10'>
					<MenuLink name='FAQ' subtitle={true} />
					{faqData?.map(({ title, slug }, index) => {
						return (
							<MenuLink
								key={index}
								name={title}
								link={`/customer-services/faq/${slug}`}
							/>
						);
					})}
				</ul>
			</div>
			<div className='d-flex'>
				<FolderIcon />
				<ul className='ml-10'>
					<MenuLink name='Legal Documents' subtitle={true} />
					{privacyData
						?.sort((a, b) => {
							return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
						})
						.map(({ title, slug }, index) => {
							return (
								<MenuLink
									key={index}
									name={title}
									link={`/customer-services/legal/${slug}`}
								/>
							);
						})}
				</ul>
			</div>
		</div>
	);
}

export default SideMenuBar;
